/**
 * @generated SignedSource<<053bb40d3485c4422dfe33eeb76378c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskSellerOrderTile_viewer$data = {
  readonly transaction?: {
    readonly item: {
      readonly firstPhotoWebPath: string | null;
      readonly title: string | null;
    } | null;
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"getOrderStatusLabel_transaction">;
  } | null;
  readonly " $fragmentType": "GetHelpZendeskSellerOrderTile_viewer";
};
export type GetHelpZendeskSellerOrderTile_viewer$key = {
  readonly " $data"?: GetHelpZendeskSellerOrderTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskSellerOrderTile_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasOrderId"
    },
    {
      "kind": "RootArgument",
      "name": "transactionId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskSellerOrderTile_viewer",
  "selections": [
    {
      "condition": "hasOrderId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "transactionId",
              "variableName": "transactionId"
            }
          ],
          "concreteType": "Transaction",
          "kind": "LinkedField",
          "name": "transaction",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "size",
                      "value": "small"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "firstPhotoWebPath",
                  "storageKey": "firstPhotoWebPath(size:\"small\")"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "getOrderStatusLabel_transaction",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isCanceled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TransactionCurrentBuyerTimelineStatus",
                  "kind": "LinkedField",
                  "name": "currentBuyerTimelineStatus",
                  "plural": false,
                  "selections": (v0/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TransactionCurrentSellerTimelineStatus",
                  "kind": "LinkedField",
                  "name": "currentSellerTimelineStatus",
                  "plural": false,
                  "selections": (v0/*: any*/),
                  "storageKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "ddccbfa61664e7fbf963978eca0771b4";

export default node;
